import React from "react";
import { TemplatePaiementErreur } from './../../Templates/index';

// Mail comptabilité
const mailPaiement = "comptabilite@cgrm.com";
// URL de paiement
const pathToPaiement = "/cotisation";

const PaiementErreur = () => {
  
  return (
    <TemplatePaiementErreur
      mail={mailPaiement}
      pathToPaiement={pathToPaiement}
    />    
  );
};

export default React.memo(PaiementErreur);
